<template>
  <div>
    <img class="main-product-show" :src="images[selectedImageIndex].url">
    <div v-if="images.length > 1" style="display: grid; margin-top: 2rem; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; grid-gap: 0.5rem; max-width: 43rem;">
      <div v-for="(image, index) in images" :key="image.url">
        <img :src="image.url" style="width: 60px; height: 60px; object-fit: cover; border-radius: 0.2rem;" @click="selectedImageIndex = index">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: { type: Array, required: true },
  },
  data() {
    return {
      selectedImageIndex: 0,
    };
  },
  methods: {
  },
};
</script>